import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-center"
      closeButton
      richColors
      style={{ zIndex: 99999 }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg group-[.toaster]:p-4",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:cursor-pointer group-[.toast]:pointer-events-auto",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground hover:bg-muted/80 group-[.toast]:cursor-pointer group-[.toast]:pointer-events-auto",
          closeButton:
            "group-[.toast]:bg-slate-100 group-[.toast]:text-slate-900 group-[.toast]:border group-[.toast]:border-slate-200 hover:group-[.toast]:bg-slate-200",
        },
      }}
      {...props} />
  );
}

export { Toaster }
